module.exports = __webpack_public_path__ + "static/media/logo.768b8027.png";